import React, {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';

var stock_id = "";
var quantity = 0;
var comment = "";
var reservation_id = 0;

function DeductStock(){
  const [FilteredStockReservations, SetFilteredStockReservations] = useState([]);

  const [StockReservations, SetStockReservations] = useState([]);
  useEffect(() => {
    const fetchReservations = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/stocks/stock_reservations.json');
      const jsonresult = await result.json()
      SetStockReservations(jsonresult)
    }
    fetchReservations();
  }, []);

  const [Stocks, SetStocks] = useState([]);
  useEffect(() => {
    const fetchStocks = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/stocks.json');
      const jsonresult = await result.json()
      SetStocks(jsonresult)
    }
    fetchStocks();
  }, []);

  const [Products, SetProducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/products.json');
      const jsonresult = await result.json()
      SetProducts(jsonresult)
    }
    fetchProducts();
  }, []);


  const [Rolls, SetRolls] = useState([]);
  useEffect(() => {
    const fetchRolls = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/stocks/stock_rolls.json');
      const jsonresult = await result.json()
      SetRolls(jsonresult)
    }
    fetchRolls();
  }, []);

  const [Roll, SetRoll] = useState({});

  const [Product, SetProduct] = useState({
      id: '',
      name: '',
      description: '',
      retail_price: '',
      trade_price: '',
      product_type_type: '',
      product_type_id: '',
      image: ''
  });

  const [StockSelected, SetStockSelected] = useState({
    id: '',
    product_id: '',
    in_stock: '',
    created_at: '',
    updated_at: '',
    price: '',
    business_unit: '',
    stock_type_type: '',
    stock_type_id: '',
    building: '',
    location: ''
  });

  const [stockchange, setstockchange] = useState(false);
  const [mode, setMode] = useState(false);
  const [DeductionMethod, setDeductionMethod] = useState(false);
  const toggleMethod= () => setDeductionMethod(!DeductionMethod);

  const SetReservation = () => {
    var Stock_Reservation_Select = document.getElementById('Stock_Reservation_Select');
    reservation_id = Stock_Reservation_Select.value;
  };

  const SelectStock = () => {
    var stock_select = document.getElementById('Stock_Select');
    var stock_value = stock_select.value;
    stock_id = Stocks.find(stock => stock.id == stock_value);

    if (stock_id == 'undefined' || stock_id == null) {
      setstockchange(false);
      SetProduct({
        id: '',
        name: '',
        description: '',
        retail_price: '',
        trade_price: '',
        product_type_type: '',
        product_type_id: '',
        image: ''
    });
      SetStockSelected({
        id: '',
        product_id: '',
        in_stock: '',
        created_at: '',
        updated_at: '',
        price: '',
        business_unit: '',
        stock_type_type: '',
        stock_type_id: '',
        building: '',
        location: ''
      });
    } else {
      SetFilteredStockReservations(StockReservations.filter(item => item.stock_id == stock_id.id));
      SetStockSelected(stock_id);
      setstockchange(true);
    };

  };

  if (stockchange == true) {
    SetProduct(Products.find(product => product.id == StockSelected.product_id));
    if (StockSelected.stock_type_type == "StockFlooringRoll") {
      SetRoll(Rolls.find(roll => roll.id == StockSelected.stock_type_id));
      setMode(true);
    } else if (StockSelected.stock_type_type == "StockConsumable") {
      setMode(false);
    } else if (StockSelected.stock_type_type == "StockFlooringPack") {
      setMode(false);
    };
    setstockchange(false);

  };

  const setComment = () => {
    var comment_id = document.getElementById('comment');
    comment = comment_id.value;
  };


  const setNew_Quantity = () => {
    var quantity_id = document.getElementById('new_quantity');
    quantity = quantity_id.value;
  };

  var myData = {};

  const submitStock = async () => {
    myData = {
      id: stock_id.id,
      quantity: quantity,
      comment: comment,
      reservation_id: reservation_id
    };

    if (mode == true){
      if (parseFloat(Roll.length) >= parseFloat(quantity) & (comment !== "" )) {
        const result = await fetch(import.meta.env.VITE_URL + '/stocks/' + stock_id.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(myData)
          })
        const resultInJson = await result.json()
        console.log(resultInJson);

      } else {
        console.log("Broken Roll");
      };
    } else if (mode == false) {
      if (StockSelected.in_stock >= quantity  & (comment !== "" )) {
        const result = await fetch(import.meta.env.VITE_URL + '/stocks/' + stock_id.id, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(myData)
        })
        const resultInJson = await result.json()
        console.log(resultInJson);
      };
    } else {
      console.log("Broken");
    };
  };

  return (
    <Form>
      <div>
        <div className="row p-1">
          <div className="col"><h1>Deduct Stock</h1></div>
          <div className="col-auto p-3">
          <Form.Check
            type="switch"
            id="custom-switch"
            label="Manual Mode"
            className="mb-3"
            value={true}
            onClick={toggleMethod}
          />
          </div>
        </div>
        <Form.Text id="stock_HelpBlock" muted>
              Select Stock
          </Form.Text>
        <InputGroup>
          <FloatingLabel id="floating_stock_label" label="Stock ID" className="mb-3">
            <Form.Control
              className="mb-1"
              type='number'
              min='1'
              onChange={SelectStock}
              id="Stock_Select"
              aria-describedby="stock_HelpBlock"
            />
          </FloatingLabel>
          <FloatingLabel id="floating_productname_label" label="Product" className="mb-3">
            <Form.Control
              readOnly
              value={Product.name}
            />
          </FloatingLabel>
          <FloatingLabel id="floating_quantity_label" label="Current Quantity" className="mb-3">
            <Form.Control
              readOnly
              type='number'
              value={StockSelected.in_stock}
            />
          </FloatingLabel>
          <FloatingLabel id="floating_business_unit_label" label="Current Business Unit" className="mb-3">
            <Form.Control
              readOnly
              value={StockSelected.business_unit}
            />
          </FloatingLabel>
        </InputGroup>
        {DeductionMethod ?
        <div>
        {mode ?
          <div>
            <FloatingLabel id="floating_current_width_label" label="Current Width (M)" className="mb-3">
              <Form.Control
                value={Roll.width}
                type='number'
                readOnly
              />
            </FloatingLabel>
            <FloatingLabel id="floating_current_length_label" label="Current Length (M)" className="mb-3">
              <Form.Control
                value={Roll.length}
                type='number'
                readOnly
              />
            </FloatingLabel>
            <FloatingLabel id="floating_deduct_length_label" label="Length to Deduct (M)" className="mb-3">
              <Form.Control
                required
                type='number'
                min='0'
                step="0.01"
                max={Roll.length}
                id='new_quantity'
                onChange={setNew_Quantity}
              />
            </FloatingLabel>
          </div>
          :
          <div>
            <FloatingLabel id="floating_deduct_quantity_label" label="Quantity to Deduct" className="mb-3">
              <Form.Control
                required
                type='number'
                min='1'
                step="1"
                max={StockSelected.in_stock}
                id='new_quantity'
                onChange={setNew_Quantity}
              />
            </FloatingLabel>
          </div>
        }
        </div>
        :
          <div>
            <Form.Text id="stock_reservation_HelpBlock" muted>
              Select Stock Reservation
            </Form.Text>
            <FloatingLabel id="floating_stock_reservations_label" label="Stock Reservation" className="mb-3">
            <Form.Select
                className="mb-1"
                aria-describedby="stock_reservation_HelpBlock"
                id="Stock_Reservation_Select"
                onChange={SetReservation}
              >
              <option>Select a Stock Reservation</option>
              {FilteredStockReservations.map(item =>
                <option key={item.id} value={item.id}>{item.quantity} - {item.reference} </option>
              )};
            </Form.Select>
          </FloatingLabel>
          </div>
        }
        <FloatingLabel id="floating_reason_label" label="Reason for Stock Deduction" className="mb-3">
            <Form.Control
              required
              type="text"
              id="comment"
              onChange={setComment}
            />
          </FloatingLabel>
        <Button type="submit" onClick={submitStock}>Submit Form</Button>
      </div>
    </Form>
  );
}

export default DeductStock;
